import type { HTMLAttributes } from 'react';

import { cn } from '../../lib/utils';

/** Card with the comic "panel" border treatment. */
export function Panel({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn(
        'rounded-panel border bg-surface shadow-[0_1px_0_0_var(--pv-surface-raised)_inset]',
        className,
      )}
      {...props}
    />
  );
}
